import React from "react";

const SimpleGauge = ({ gameStatus, selectedMetric }) => {
  const metric = gameStatus.score_dic[selectedMetric];

  if (!metric) return <div className="simple-gauge-error">Métrique introuvable</div>;

  const { name, value, max } = metric;
  const maxValue = max ?? 10;
  const percentage = (value / maxValue) * 100;
  const dangerZone = (3 / maxValue) * 100;

  return (
    <div className="simple-gauge-container">
      <div className="simple-gauge-title">{name}</div>
      <div className="simple-gauge-value">{value} / {maxValue}</div>
      <div className="simple-gauge-bar-wrapper">
        <div className="simple-gauge-bar">
          <div className="simple-gauge-danger-zone" style={{ width: `${dangerZone}%` }}></div>
        </div>
        <div className="simple-gauge-indicator" style={{ left: `calc(${percentage}% - 12px)` }}></div>
      </div>
    </div>
  );
};

export default SimpleGauge;
